import { BaseService } from "../BaseService";
import { ICTCAccountService } from "../interfaces/ICTCAccountsService";
import { IUserService } from "../interfaces/IUserService";
import { IStatus } from "../interfaces/IStatus";
import { httpClient } from "../HttpClient";
import { AxiosRequestConfig } from "axios";
import { IUser } from "../interfaces/IUser";
import { sign } from "crypto";

export class UserService implements BaseService, IUserService {
  public END_POINT: string = "accounts";
  public VERSION: string = process.env.VUE_APP_ACCOUNTS_VERSION;
  public USERS: string = "users";
  public STATUSES: string = "statuses";
  public ROLES: string = "roles";
  public SIGNUP: string = "signup";

  public async getUserStatuses(config?: AxiosRequestConfig): Promise<IStatus> {
    return await httpClient.get<IStatus>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${this.STATUSES}`
    );
  }

  public async createOrganizationAdmin(orgAdmin, organization): Promise<IUser> {
    return await httpClient.post<IUser>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${organization.id}`,
      orgAdmin
    );
  }

  public async assignOrganizationAdmin(id: string, role): Promise<object> {
    return await httpClient.post<object>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${id}/${this.ROLES}`,
      role
    );
  }

  public async removeOrganizationAdmin(id, role): Promise<object> {
    return await httpClient.patch<object>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${id}/${this.ROLES}`,
      role
    );
  }

  public async getOrganizationRoles(): Promise<Array<object>> {
    return await httpClient.get<Array<object>>(
      `${this.END_POINT}/${this.VERSION}/${this.ROLES}`
    );
  }

  public async searchUsers(config?: AxiosRequestConfig): Promise<Array<IUser>> {
    return await httpClient.get<Array<IUser>>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/search`,
      config
    );
  }

  public async getUserRoles(id): Promise<Array<string>> {
    return await httpClient.get<Array<string>>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${id}/roles`
    );
  }

  public async exportUsersandGroups(organizationId: string) {
    return await httpClient.get(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${organizationId}/export-users`
    );
  }

  public async getStatuses(includeHiddenStatuses: boolean): Promise<IStatus> {
    return await httpClient.get<IStatus>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/statuses?includeHiddenStatuses=${includeHiddenStatuses}`
    );
  }
  public async updateStatus(id: string, config?: AxiosRequestConfig) {
    return await httpClient.patch(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${id}/status`,
      config
    );
  }
  public async changeEmail(id: string, config?: object) {
    return await httpClient.patch(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${id}/email`,
      config
    );
  }
  public async changePassword(id: string, config?: object) {
    return await httpClient.patch(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${id}/password`,
      config
    );
  }
  public async getRoles() {
    return await httpClient.get(
      `${this.END_POINT}/${this.VERSION}/${this.ROLES}`
    );
  }

  public async assignRoles(id: string, config?: object) {
    return await httpClient.post(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/${id}/roles`,
      config
    );
  }
  public async searchUsersByRoles(
    config?: AxiosRequestConfig
  ): Promise<Array<IUser>> {
    return await httpClient.get<Array<IUser>>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/role`,
      config
    );
  }
  public async signUpUser(id: string, signUp: boolean) {
    return await httpClient.get(
      `${this.END_POINT}/${this.VERSION}/${this.SIGNUP}/user/${id}/${signUp}`
    );
  }
  public async changeUserOrg(config?: object) {
    return await httpClient.patch(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/bulk-transfer-organization`,
      config
    );
  }

  public async getallUsers(config?: AxiosRequestConfig): Promise<Array<IUser>> {
    return await httpClient.get<Array<IUser>>(
      `${this.END_POINT}/${this.VERSION}/${this.USERS}/all-users-cmp`,
      config
    );
  }
}
